import { useEffect } from 'react'

/**
 * Lock document scroll (e.g. while a full-screen mobile menu is open).
 */
export function useBodyScrollLock(locked) {
  useEffect(() => {
    if (!locked) return
    const previous = document.body.style.overflow
    document.body.style.overflow = 'hidden'
    return () => {
      document.body.style.overflow = previous
    }
  }, [locked])
}
